/** @jsxImportSource @emotion/react */
import React from 'react'

interface PersonAddIconProps {
  size?: number
  color?: string
}

const PersonAddIcon: React.FC<PersonAddIconProps> = ({
  size = 24,
  color = '#27303E',
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
  >
    <path
      d='M15.39 14.56C13.71 13.7 11.53 13 9 13C6.47 13 4.29 13.7 2.61 14.56C1.61 15.07 1 16.1 1 17.22V20H17V17.22C17 16.1 16.39 15.07 15.39 14.56ZM9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM20 9V7C20 6.45 19.55 6 19 6C18.45 6 18 6.45 18 7V9H16C15.45 9 15 9.45 15 10C15 10.55 15.45 11 16 11H18V13C18 13.55 18.45 14 19 14C19.55 14 20 13.55 20 13V11H22C22.55 11 23 10.55 23 10C23 9.45 22.55 9 22 9H20Z'
      fill={color}
    />
  </svg>
)

export default PersonAddIcon
